<script>
    import { Loader } from "./index.svelte";

    export let title = "",
        btnOptions = [],
        bottomLinks = [],
        onExpandCollapse,
        id,
        flex1 = false,
        isBtnNextToTitle = false,
        defaultExpanded = true,
        enableCollapse = true,
        headerClass = "",
        cardClass = "";

    // btnOption = {
    //     iconName: String,
    //     isHidden: Boolean,
    //     isDisabled: Boolean,
    //     iFont: String,
    //     iconFunction: Function,
    //     isLoading: Boolean,
    //     hasTooltip: Boolean,
    //     tooltip: String,
    // }

    // bottomLink = {
    //     displayName: String,
    //     isHidden: Boolean,
    //     isDisabled: Boolean,
    //     clickFunc: Function,
    //     isLoading: Boolean,
    //     hasTooltip: Boolean,
    //     tooltip: String,
    // }

    // HELPER FUNCTIONS
    const _toggleShowHideCard = (e) => {
        if (!btnOptions.length) {
            if (enableCollapse) {
                defaultExpanded = !defaultExpanded;
                if(onExpandCollapse){
                    onExpandCollapse(defaultExpanded);
                }
            }
            else return;
        } else if (
            btnOptions.some((option) =>
                e.target.className.includes(option.iconName),
            )
        ) {
            const selectedIcon = btnOptions.find((option) =>
                e.target.className.includes(option.iconName),
            );
            if (!selectedIcon.isDisabled && selectedIcon.iconFunction)
                selectedIcon.iconFunction();
        } else if (enableCollapse) {
            defaultExpanded = !defaultExpanded;
            if(onExpandCollapse){
                onExpandCollapse(defaultExpanded);
            }
        }
        else return;
    };
</script>

<div
    class={`transition flex flex-col w-full ${flex1 ? "flex-1" : ""} ${
        defaultExpanded ? "" : "max-h-[50px]"
    }`}
    {id}
>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        class={`${headerClass} flex gap-x-4 pr-2 text-white bg-gradient-to-b from-primary to-secondary  items-center rounded-t-lg h-[50px] ${
            isBtnNextToTitle ? "justify-start" : "justify-between"
        } ${enableCollapse ? "cursor-pointer" : "cursor-default"} ${defaultExpanded ? "rounded-b-none" : "rounded-b-lg"}`}
        on:click|preventDefault={_toggleShowHideCard}
    >
        <div class="flex flex-row items-center">
            {#if enableCollapse}
                <p class="font-bold pl-4 pr-1">
                    {#if defaultExpanded}
                        <i class="fa-solid fa-caret-up"></i>
                    {:else}
                        <i class="fa-solid fa-caret-down"></i>
                    {/if}
                </p>
            {/if}
            <p class="font-bold px-2 py-4">{title}</p>
        </div>

        {#if btnOptions.length}
            <div class="flex flex-1 items-center gap-x-4 justify-end">
                {#each btnOptions as btn}
                    {#if !btn.isHidden}
                        {#if btn.isLoading}
                            <Loader />
                        {:else}
                            <div
                                class={`flex items-center gap-x-2 ${
                                    btn.iconName
                                } ${
                                    btn.hasTooltip
                                        ? `tooltip tooltip-secondary ${
                                              isBtnNextToTitle
                                                  ? "tooltip-right"
                                                  : "tooltip-left"
                                          }`
                                        : ""
                                } ${
                                    btn.isDisabled
                                        ? "cursor-not-allowed"
                                        : "cursor-pointer"
                                }`}
                                data-tip={`${
                                    btn.hasTooltip ? btn.tooltip : ""
                                }`}
                            >
                                {#if btn.iFont}
                                    <i
                                        class={`${btn.iconName} ${btn.iFont} text-[16px]`}
                                    />
                                {:else if btn.svgIcon}
                                    {@html btn.svgIcon}
                                {/if}

                                {#if btn.btnText}
                                    <p
                                        class={`${btn.iconName} text-[16px] font-bold`}
                                    >
                                        {btn.btnText}
                                    </p>
                                {/if}
                            </div>
                        {/if}
                    {/if}
                {/each}
            </div>
        {/if}
    </div>

    {#if defaultExpanded}
        <div
            class={`flex flex-1 h-full card ${cardClass} bg-white rounded-none rounded-b-lg border overflow-visible`}
        >
            <slot />

            {#if bottomLinks.length}
                <div
                    class="flex flex-1 items-center justify-center gap-x-4 p-4"
                >
                    {#each bottomLinks as link}
                        {#if !link.isHidden}
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <!-- svelte-ignore a11y-no-static-element-interactions -->
                            <div
                                class={`flex items-center justify-center gap-x-2 ${
                                    link.isLoading || link.isDisabled
                                        ? "cursor-not-allowed"
                                        : "cursor-pointer"
                                } ${
                                    link.hasTooltip
                                        ? "tooltip tooltip-secondary"
                                        : ""
                                }`}
                                data-tip={`${link.hasTooltip ? link.tooltip : ""}`}
                                on:click|preventDefault={link.isLoading ||
                                link.isDisabled
                                    ? () => {}
                                    : link.clickFunc}
                            >
                                <p class="underline hover:font-bold">
                                    {link.displayName}
                                </p>
                                {#if link.isLoading}
                                    <div>
                                        <Loader />
                                    </div>
                                {/if}
                            </div>
                        {/if}
                    {/each}
                </div>
            {/if}
        </div>
    {/if}
</div>

<style>
    .transition {
        transition: 0.5s linear;
    }

    .card-layout-empty-header {
        background: white !important;
    }

    .card-layout-empty-header .font-bold {
        color: #270053;
    }
</style>
